export class UserCompletionInfo {
  constructor(
    public readonly userInputId: number,
    public readonly isCompleted: boolean,
    public readonly externalCompletionOnly?: boolean,
    public readonly isVerified?: boolean
  ) {}
}
